import { defineStore } from 'pinia';
import { $fetch } from '@/conference/2025-2/utils/fetch';
import { ref } from 'vue';

export interface SiteConfig {
  name: string,
  title: string,
  logo: string,
  subName: string,
  description: string,
  pic: string,
  guideUrl: string,
  speakerTotal: number,
  pictureTotal: number,
  extInfo: Record<string, any>,
}

export const getSpeakerTotal = async () => {
  const { isSuccess, data } = await $fetch('/web/meeting/v1/guest/count', {
    data: {
      meetingCode: import.meta.env.VITE_ENABLED_CONFERENCE_CODE,
    },
  });

  if (isSuccess) {
    return data;
  }

  return 0;
};

export const getPictureTotal = async () => {
  const { isSuccess, data } = await $fetch('/web/meeting/v1/photo/wall/count', {
    data: {
      meetingCode: import.meta.env.VITE_ENABLED_CONFERENCE_CODE,
    },
  });

  if (isSuccess) {
    return data;
  }

  return 0;
};

export const useAppStore = defineStore('app', () => {
  const config = ref<SiteConfig>({
    name: '',
    title: '',
    logo: '',
    subName: '',
    description: '',
    pic: '',
    guideUrl: '',
    speakerTotal: 0,
    pictureTotal: 0,
    extInfo: {},
  });

  const fetchConfig = async () => {
    const { isSuccess, data } = await $fetch('/web/meeting/v1/meet/detail', {
      data: {
        code: import.meta.env.VITE_ENABLED_CONFERENCE_CODE,
      },
    });

    if (isSuccess) {
      config.value = {
        name: data.name,
        title: data.subject,
        logo: '',
        subName: data.subName,
        description: data.description,
        pic: data.pic,
        guideUrl: data.guideUrl,
        extInfo: data.extInfo,
        speakerTotal: await getSpeakerTotal(),
        pictureTotal: await getPictureTotal(),
      };
    }

    return { isSuccess };
  }

  return {
    fetchConfig,
    config,
  };
});
